import styled from '@emotion/styled'
import { TextLink } from '../../../../../../typography/TextLink/TextLink'
import { colors } from '../../../../../../__styling/settings/colors'
import { zIndex } from '../../../../../../__styling/settings/z-index'
import { breakpoint } from '../../../../../../__styling/style-functions/breakpoint'
import { calcRem } from '../../../../../../__styling/style-functions/calc-rem'
import {
    fluidTypography,
    transition,
} from '../../../../../../__styling/style-mixins'
import { themedValue } from '../../../../../../__styling/themed-value'
import { Theme } from '../../../../../../__styling/themes'

export const StyledBreachWallContent = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    zIndex: zIndex.common.regWall.box,
    fontFamily: theme.fonts.subscriber.text,
    fontSize: calcRem(18),
    color: colors.white,
    padding: calcRem(theme.margins.md, 0),
    backgroundBlendMode: 'overlay, normal',

    background: themedValue(theme, {
        thewest: theme.sectionValues.primaryColor,
        perthnow: colors.perthnow.greyBasalt90,
        sevennews: colors.sevennews.charade,
    }),
    [breakpoint('xxs')]: {
        paddingTop: calcRem(theme.margins.lg),
        paddingBottom: calcRem(theme.margins.md),
    },
}))

export const StyledRegistrationInfo = styled('div')(({ theme }) => ({}))

const fluidTitle = (theme: Theme) =>
    themedValue(theme, {
        sevennews: fluidTypography(0, 1000, 24, 30),
        perthnow: fluidTypography(0, 1020, 24, 30),
        thewest: fluidTypography(0, 1220, 48, 56),
    })

export const StyledTitle = styled('h2')(({ theme }) => ({
    position: 'relative',
    margin: calcRem(theme.margins.sm),
    fontWeight: 700,
    textAlign: 'center',
    lineHeight: 1.267,

    ...fluidTitle(theme),

    [breakpoint('xs')]: {
        margin: calcRem(0, 0, theme.margins.sm, 0),
    },
}))

export const StyledMessage = styled('div')(({ theme }) => ({
    marginBottom: calcRem(theme.margins.sm),
    maxWidth: calcRem(500),
    p: {
        margin: calcRem(0, theme.margins.sm),
        fontsize: calcRem(20),
        textAlign: 'center',
    },
}))

export const StyledPackage = styled('div')(({ theme }) => ({
    flexGrow: 1,
    flexBasis: 400,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    margin: 0,

    [breakpoint('xs')]: {
        margin: calcRem(0, theme.margins.md),
    },
}))

export const StyledButton = styled('button')(({ theme }) => ({
    display: 'inline-block',
    border: `1px solid ${colors.white}`,
    padding: calcRem(theme.margins.sm, theme.margins.xl),
    marginTop: calcRem(theme.margins.lg),
    background: 'none',
    color: colors.white,
    borderRadius: calcRem(2),
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 700,
    fontSize: calcRem(13),
    textDecoration: 'none',
    textTransform: 'uppercase',
    cursor: 'pointer',
    ...transition({ properties: ['background', 'color'] }),

    '&:hover': {
        backgroundColor: colors.white,
        color: themedValue(theme, {
            thewest: colors.thewest.greyGorilla,
            perthnow: colors.perthnow.blueKyanite,
            sevennews: colors.sevennews.red,
        }),
    },

    '&:focus': {
        backgroundColor: themedValue(theme, {
            thewest: colors.thewest.greyGorilla,
            perthnow: colors.perthnow.pinkThulite,
            sevennews: colors.sevennews.red,
        }),
        borderColor: themedValue(theme, {
            thewest: colors.thewest.greyGorilla,
            perthnow: colors.perthnow.pinkThulite,
            sevennews: colors.sevennews.red,
        }),
        color: 'currentColor',
        outline: 'none',
        textDecoration: 'underline',
    },
}))

export const StyledPrintDigTitle = styled(StyledTitle)({
    fontSize: calcRem(23), // DPT-3294: campaign requires specific sizing
})

export const StyledTerms = styled('p')(({ theme }) => ({
    color: colors.white,
    margin: 0,
    marginTop: calcRem(theme.margins.sm),
    fontSize: calcRem(11),
}))

export const StyledLiveTrailerWrap = styled('div')({
    margin: `${calcRem(30)} auto`,
    boxShadow: '0 0 16px rgba(0,0,0,0.5)',
})

export const StyledHelpMessage = styled('p')(({ theme }) => ({
    margin: calcRem(theme.margins.sm, 0),
}))

export const StyledTextLink = styled(TextLink)<{ reverseColor: boolean }>(
    ({ reverseColor }) => ({
        color: reverseColor ? colors.white : undefined,
    }),
)
